import * as React from 'react';
import { ConfigurationSummaryDivider } from '../../../steps/components/ConfigurationSummaryDivider/ConfigurationSummaryDivider.js';
import ConfigurationSummaryRow from '../../../steps/components/ConfigurationSummaryRow/ConfigurationSummaryRow.js';
import FrameInformationContainer from '../../../steps/components/FrameInformation/FrameInformationContainer.js';
import { getBundleProductTitle } from '../../../utils/get-bundle-product-title.js';

const ConfigurationSummary = ({ labels , frame , addOn , lensType , lensPackage , bundlePrice , isPhone , isSmallScreen , hasVisitedStepLensPackage , hasVisitedStepAddOn , totalPricePrefix , minimumBundleSupplement ,  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, frame && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: /*#__PURE__*/ React.createElement(FrameInformationContainer, {
            showImage: isPhone,
            textOrientation: isPhone ? 'vertical' : 'horizontal'
        }),
        price: frame.price
    }), /*#__PURE__*/ React.createElement("div", {
        className: "glasses-configuration-summary",
        "data-t": "configuration-summary"
    }, lensType && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: isSmallScreen
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.lensType,
        value: getBundleProductTitle(lensType),
        price: lensType.price,
        discountText: lensType.discountText,
        step: "lensType",
        "data-t": "configuration-summary-row-lens-type"
    })), hasVisitedStepLensPackage && lensPackage && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.lensPackage,
        value: lensPackage.title,
        price: lensPackage.price,
        discountText: lensPackage.discountText,
        step: "lensPackage",
        "data-t": "configuration-summary-row-lens-package"
    }), hasVisitedStepAddOn && addOn && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.addOn,
        value: getBundleProductTitle(addOn),
        price: addOn.price,
        discountText: addOn.discountText,
        step: "lensAddOn",
        "data-t": "configuration-summary-row-add-on"
    }), minimumBundleSupplement && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: isSmallScreen
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.minimumBundleSupplement,
        price: minimumBundleSupplement,
        "data-t": "configuration-summary-row-minimum-supplement"
    })), /*#__PURE__*/ React.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: isSmallScreen
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.totalPrice,
        price: bundlePrice,
        priceSize: "medium",
        pricePrefix: totalPricePrefix,
        "data-t": "configuration-summary-row-total-price"
    })))
;

export { ConfigurationSummary as default };
//# sourceMappingURL=ConfigurationSummary.js.map
